import { render, staticRenderFns } from "./AlterarEmail.vue?vue&type=template&id=7a571937"
import script from "./AlterarEmail.vue?vue&type=script&lang=ts"
export * from "./AlterarEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports